@if(o.isActivated && (isLoading$ | async) && (isAuthenticated$ | async)) {
<shared-global-loading></shared-global-loading>
}
<router-outlet #o="outlet"></router-outlet>
<shared-build-info></shared-build-info>
<shared-connection-status [connectionStatus]="isConnected$ | async"></shared-connection-status>
